import { Link, usePage } from '@inertiajs/react'
import { useShared } from '../lib/hooks'

export default function Header() {
  const { cart, auth } = useShared()
  const here = usePage().url
  // Return the user to where they were after signing in (but not auth pages).
  const signInHref = /^\/(login|register)/.test(here)
    ? '/login'
    : `/login?return_to=${encodeURIComponent(here)}`

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-ink/85 backdrop-blur">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 h-16 flex items-center justify-between gap-6">
        <Link href="/" className="flex items-baseline gap-2 group shrink-0">
          <span className="text-lg font-semibold tracking-tight whitespace-nowrap">Forma Sound</span>
          <span className="mono-label hidden sm:inline !text-[10px] group-hover:text-paper transition-colors">
            FS / 001
          </span>
        </Link>

        <nav className="flex items-center gap-4 sm:gap-7 shrink-0 [&_a]:whitespace-nowrap">
          <Link
            href="/packs"
            className="mono-label hover:text-paper transition-colors"
            prefetch
          >
            Catalog
          </Link>

          {auth.user ? (
            <Link href="/account" className="mono-label hover:text-paper transition-colors">
              Account
            </Link>
          ) : (
            <Link href={signInHref} className="mono-label hover:text-paper transition-colors">
              Sign in
            </Link>
          )}

          <Link
            href="/cart"
            className="mono-label hover:text-paper transition-colors flex items-center gap-1.5"
            aria-label={`Cart, ${cart.count} items`}
          >
            <span>Cart</span>
            <span className="tabular-nums inline-grid place-items-center min-w-5 h-5 px-1 rounded-full border border-line-2 text-paper">
              {cart.count.toString().padStart(2, '0')}
            </span>
          </Link>
        </nav>
      </div>
    </header>
  )
}
